import React from 'react';
import { Link } from 'react-router-dom';
import { Tooltip, Typography, Button } from '@mui/material';
import { Page, Row, Fill } from '../util/Page';
import PastRequests from './PastRequests';

import './data-request.css';

const DataRequest = () => (
  <div style={{ display: 'grid' }}>
    <Page>
      <Row>
        <Typography variant="h5" className="page-title">
          Launch Your Project
        </Typography>
        <Fill />
        <Tooltip title="Click here if you are connecting to a brand new building. You have not accessed this building's network before nor another network at this location.">
          <Button component={Link} className="nav-button" to="/data-request/new">
            Start New Project
          </Button>
        </Tooltip>
        <Tooltip title="Click here if you are looking to add or edit assets withing an existing building. Or, you are accessing another network within an existing building.">
          <Button component={Link} className="nav-button" to="/data-request/existing">
            Update Live Project
          </Button>
        </Tooltip>
      </Row>
    </Page>
    <Page>
      <Row>
        <Typography variant="h5" align="left">
          Project List
        </Typography>
      </Row>
      <Row>
        <PastRequests />
      </Row>
    </Page>
  </div>
);

export default DataRequest;
